const pad = (n) => String(n).padStart(2, '0');

/** Local calendar day, YYYY-MM-DD. */
export function today(now = new Date()) {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** Now, with the browser's UTC offset, so the server knows which day "today" is here. */
export function capturedAt(now = new Date()) {
  const offset = -now.getTimezoneOffset();
  const sign = offset >= 0 ? '+' : '-';
  const abs = Math.abs(offset);
  return `${today(now)}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}${sign}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
}

/**
 * The instant to store for an approved day, as the phone does it: the
 * capture time when the interaction happened today, else noon that day.
 */
export function instantFor(day, now = new Date()) {
  if (!day || day === today(now)) return now.toISOString();
  const [y, m, d] = day.split('-').map(Number);
  return new Date(y, m - 1, d, 12, 0, 0).toISOString();
}
